// src/pages/WelcomePage.jsx

import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/Button";

export default function WelcomePage() {
  return (
    <div className="welcome">
      <div className="welcome_left">
        <div className="welcome_title">
          Добро пожаловать <br /> в <span className="welcome_subtext">ONZA KG</span>
        </div>
        <div className="welcome_text">
          Быстрая и надежная<br /> доставка заказов из США и Испании

        </div>
        <div className="welcome_btns">
          <Link to={"orders"}><Button>Войти</Button></Link>
          <Link to={"register"}><Button>Зарегистрироваться</Button></Link>
        </div>
      </div>
      <div className="welcome_right">
        <img src="new-logo.jpg" alt="" className="welcome_right_img" />
      </div>
    </div>
  );
}
